import React, { useState, useEffect } from 'react';
import '../../css/Shared/UploadXlsxFile.css';
import upload from '../../Assets/ProfileManagement/Assets-Desktop/upload.svg';
import closeIcon from '../../Assets/ProfileManagement/Assets-Desktop/close.svg';
import uploadDisable from '../../Assets/ProfileManagement/Assets-Desktop/uploadDisable.svg';
import { ApiCall } from '../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../Services/config/apiGateway';
import { DOCUMENT_ENDPOINT } from '../../Services/config/apiEndPoints';
import { Link } from 'react-router-dom';


const UploadXlsxFile = (props) => {
    const [fileName, setFileName] = useState("");
    const [isUploadDisabled, setIsUploadDisabled] = useState(false);

    function anchorClick(e) {
        e.preventDefault();
        document.querySelector('#' + props.idupload).click();
    }



    useEffect(() => {
        window.$(function () {
            var fileupload = document.getElementById(props.idupload);
            fileupload.onchange = function (e) {
                let files = e.target.files[0];
                if (fileupload.value.match(/xlsx$/)) {
                    if (fileupload.files.length > 0) {
                        for (let i = 0; i <= fileupload.files.length - 1; i++) {
                            const fsize = fileupload.files.item(i).size;
                            const file = Math.round((fsize / 1024));
                            if (file > 2048) {
                                alert("File too big, please select a file less than 2 MB");
                            }
                            else {

                                const reader = new window.FileReader();
                                reader.readAsDataURL(files);

                                reader.onload = (f) => {
                                    const formData1 = new window.FormData();
                                    formData1.append('file', files);
                                    console.log("before api call", formData1);
                                    ApiCall(
                                        'POST',
                                        utilityBaseURL +
                                        DOCUMENT_ENDPOINT,
                                        formData1,

                                        {
                                            Accept: 'application/json',

                                        },
                                        true,
                                        true
                                    ).then((response) => response)
                                        .then((data) => {
                                            if (data.flag != -1) {
                                                console.log('I am 200!');
                                                console.log("file path api", data.documentPath);
                                                setIsUploadDisabled(true);
                                                var uploadedfileName = fileupload.value.split('\\')[fileupload.value.split('\\').length - 1];
                                                setFileName(uploadedfileName);

                                                alert("File uploaded sucessfully");
                                                props.setUploadConfirm(true);
                                                props.setFileLink(data.documentPath);

                                            } else {

                                                props.setLoader(false);

                                            }
                                        });

                                }
                            }
                        }
                    }
                }

                else { alert("File should be xlsx.") }
            };
        });
    }, []);
    return (
        <div class="predocuupload" id={props.uploaddivid}>
            <div>
                <span style={{ display: isUploadDisabled ? "flex" : "none" }} id={props.vatFile} className="predocfilename">
                    <div className="predocuploadedFilenameimg">
                        <div className="predocuploadedfilename">{fileName}</div>
                        <img alt="" onClick={() => {
                            document.querySelector('#' + props.idupload).value = null;
                            setIsUploadDisabled(false);
                            console.log('close requested')
                        }} src={closeIcon} width="45" height="45" class="pb-1" />
                    </div>
                </span><hr className="predocspanhr" style={{ display: isUploadDisabled ? "flex" : "none" }} />
            </div>
            <div className="predocshowupload">
                <div class="predocuuploadsize">
                    <img src={isUploadDisabled ? uploadDisable : upload}

                        id={props.uploadicon}
                        class="mt-1"
                        alt="" width="15" height="15" loading="lazy" />
                    <input id={props.idupload} name={props.name} type="file" required disabled={isUploadDisabled} />
                    <Link to="#" style={{ color: isUploadDisabled ? "#C4C4C4" : "#d42e12" }}

                        id={props.upload_link}
                        class="pl-2" onClick={anchorClick}
                    >Upload File</Link>
                </div>
                <div class="predocufilesize">
                    <div class="predocudisflex1">
                        <small class="predocfile"> Type : </small>
                        <small class="predocfile1"> xlsx</small>
                    </div>
                    <div class="predocudisflex2">
                        <small class="predocfile"> Size : </small>
                        <small class="predocfile1"> 2 MB (Max.)</small>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default UploadXlsxFile;


